import React from 'react'
import { Switch, Route } from 'react-router-dom'
import RouteWithSubRoutes from 'components/common/RouteWithSubRoutes/RouteWithSubRoutes'
import DetailsRoute from './Details'
import ListRoute from './List'

const BaseComponent = () => (
  <Switch>
    <Route exact path="/flows/:id" component={DetailsRoute} />
    <Route exact path="/flows" component={ListRoute} />
  </Switch>
)

export default () => (
  <RouteWithSubRoutes
    path="/flows"
    baseComponent={BaseComponent}
    subRoutes={[
      /^\/flows$/,
      /^\/flows\/(\d)+$/,
    ]}
  />
)
